export default "__VITE_ASSET__Jy_Wq_4I__"